import { COUPON_STATES } from '../../constants';
import { authApiCall } from '../auth/saga';

export const getBusinessCoupons = (params) => {
  // console.log('getBusinessCoupons params:', params);

  return authApiCall({
    url: '/coupons/',
    method: 'get',
    params,
  });
};

export const publishCoupon = id =>
  authApiCall({
    url: `/coupons/${id}/publish/`,
    method: 'post',
  });

export const deleteCoupon = id =>
  authApiCall({
    url: `/coupons/${id}/`,
    method: 'delete',
  });

export const sponsorCoupon = id =>
  authApiCall({
    url: `/coupons/${id}/sponsor/`,
    method: 'post',
  });

export const getViewCounts = coupon_ids =>
  authApiCall({
    url: `/coupons/get-view-counts/`,
    method: 'post',
    data: coupon_ids,
  });

export const republishCoupon = data => {
  const coupon_images = Array.isArray(data.image_url)
    ? data.image_url.reduce((a, c) => {
        a.push(c.id);
        return a;
      }, [])
    : [];

  const formattedData = {
    ...data,
    ...(data.category ? { category: data.category.id } : {}),
    state: COUPON_STATES.PUBLISHED,
    coupon_images,
  };
  return authApiCall({
    url: `/coupons/`,
    method: 'post',
    data: formattedData,
  });
};

export const getWebsiteCityCoupons = params =>
  authApiCall({
    url: '/coupons/category-coupon-list/',
    method: 'post',
    data: {
      category_ids: (params && params.category_ids) || null,
      search_string: (params && params.search_string) || null,
      city: (params && params.city) || null,
      page: (params && params.page) || 1,
    },
  });
export const getAffiliateCoupons = (creatorId) =>
  authApiCall({
    url: `/coupons/affiliate-business-coupons/${creatorId}/`,
    method: 'get',
  });

// ─────────────────────────────────────────────────────────────────────────
// Customer-facing (ported from mobile app) — coupon browsing, favourites,
// applying/reserving coupons, and reporting.
// ─────────────────────────────────────────────────────────────────────────

export const getCategorizedList = (params = {}) => {
  const {
    page,
    city,
    category_ids,
    search_string,
    category,
    subcategory,
    ...rest
  } = params;

  const data = {
    city: city,
    search_string: search_string,
    category_ids: category_ids,
    subcategory_ids: subcategory,
    published_only: true,
    ...rest,
  };

  Object.keys(data).forEach(k => data[k] == null && delete data[k]);

  return authApiCall({
    url: '/coupons/category-coupon-list/',
    method: 'post',
    params: page ? { page } : {},
    data,
  });
};

export const getCategoryList = (params) => {
  return authApiCall({
    url: '/coupons/categories/',
    method: 'GET',
    params,
  });
};

export const getRecommendedList = (location, city, distance_based_sorting) => {
  return authApiCall({
    url: '/coupons/recommended-coupon-list/',
    method: 'post',
    data: {
      location,
      city,
      distance_based_sorting,
    },
  });
};

export const getAllList = (params = {}) => {
  const { page, city, ...rest } = params;

  const data = {
    city: city ,
    published_only: true,
    ...rest,
  };

  Object.keys(data).forEach(k => data[k] == null && delete data[k]);

  return authApiCall({
    url: '/coupons/category-coupon-list/',
    method: 'post',
    params: page ? { page } : {},
    data,
  });
};

export const getApplyCouponList = params => {
  return authApiCall({
    url: '/coupons/apply-coupon/',
    method: 'get',
    params,
  });
};

export const getApplyCoupon = id => {
  return authApiCall({
    url: `/coupons/apply-coupon/${id}/`,
    method: 'get',
  });
};

export const getDetail = id => {
  return authApiCall({
    url: `/coupons/coupon-detail/${id}/`,
    method: 'get',
  });
};

export const applyCoupon = (couponId, payByPoints = false) => {
  return authApiCall({
    url: '/coupons/apply-coupon/',
    method: 'post',
    data: {
      coupon: couponId,
      pay_by_points: payByPoints,
    },
  });
};

export const reserveCoupon = couponId => {
  return authApiCall({
    url: '/coupons/reserve-coupon/',
    method: 'post',
    data: {
      coupon: couponId,
    },
  });
};

export const cancelAppliedCoupon = appliedCouponId => {
  return authApiCall({
    url: `/coupons/apply-coupon/${appliedCouponId}/cancel/`,
    method: 'post',
  });
};

export const sendReport = data => {
  return authApiCall({
    url: '/coupons/reports/',
    method: 'post',
    data,
  });
};

export const getAllFavourites = params => {
  return authApiCall({
    url: '/coupons/list-save-coupon/',
    method: 'get',
    params,
  });
};

export const markCouponAsFavourite = coupon_id => {
  return authApiCall({
    url: '/coupons/save-coupon/',
    method: 'post',
    data: {
      coupon_id,
    },
  });
};

export const removeFavouriteCoupon = coupon_id => {
  return authApiCall({
    url: '/coupons/delete-save-coupon/',
    method: 'delete',
    data: {
      coupon_id,
    },
  });
};

export const getCouponsByBusinessIds = business_ids => {
  return authApiCall({
    url: '/coupons/coupons-by-business-ids/',
    method: 'post',
    data: { business_ids },
  });
};

export const getFilteredCoupons = params => {
  return authApiCall({
    url: '/coupons/filtered/',
    method: 'get',
    params: {
      category: params.category || null,
      subcategory: params.subcategory || null,
      state: params.state || null,
      published_only: params.published_only || null,
      created_after: params.created_after || null,
      created_before: params.created_before || null,
      city: params.city || null,
      search_string: params.search_string || null,
      page: params.page || null,
    },
  });
};

export const getBrowseList = (params = {}) => {
  const { page, ...filters } = params;
  const data = {};
  ['cities', 'category_ids', 'subcategory_ids', 'search_string'].forEach(k => {
    const v = filters[k];
    if (v == null || v === '' || (Array.isArray(v) && v.length === 0)) return;
    data[k] = v;
  });
  return authApiCall({
    url: '/coupons/browse-coupon-list/',
    method: 'post',
    params: page ? { page } : {},
    data,
  });
};